import MeditationDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/MeditationDetailResponse";
import UpdateMeditationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationRequest";
import AudioGroupViewModel from "./audioGroupViewModel";
import MeditationAudioViewModel from "./meditationAudioViewModel";
import MeditationTranslateViewModel from "./meditationTranslateViewModel";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import VoiceFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/VoiceFileResponse";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";

export default class CreateMeditationViewModel {
    id?: number = null;
	isSleep: boolean = false;
	isPaid: boolean = false;
	useOnMainDisplay: boolean = false;
	useBackgroundMusic: boolean = true;
	categoriesIds: Array<number> = null;
	animationId: string = null;
	animationUrl: string = '';
	audios: Array<AudioGroupViewModel> = [];
	translations: Array<MeditationTranslateViewModel> = null; // 
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	initLanguages(languages: string[]) {
		this.translations = languages.map(
			(x) =>
			  new MeditationTranslateViewModel({
				langCode: x,
			  })
		  );
	}
	toServerModel(): UpdateMeditationRequest {
		const req = new UpdateMeditationRequest({
			Id: this.id,
			IsSleep: this.isSleep,
			IsPaid: this.isPaid,
			UseOnMainDisplay: this.useOnMainDisplay,
			UseBackgroundMusic: this.useBackgroundMusic,
			AnimationId: this.animationId,
			CategoriesIds: this.categoriesIds,
			Back: mapToCropRequest(this.backgroundImage), // this.coverImage,
			Cover: mapToCropRequest(this.coverImage), // this.coverImage,
			Translations: this.translations.map(x=>x.toServerModel())
		});
		this.audios.forEach(audioGroup => {
			req.Translations.forEach(tr => {
				if (!tr.VoiceFiles) {
					tr.VoiceFiles = [];
				}
				const audios = audioGroup.audios.filter(x=>x.langCode == tr.LangCode);
				if (audios.length > 0) {
					tr.VoiceFiles.push(...(audios.map(a=>a.toServerModel())));
				}
			});
		});
		return req;
	}
	fromServerModel(model: MeditationDetailResponse) {
		this.id = model.Id;
		this.isSleep = model.IsSleep;
		this.isPaid = model.IsPaid;
		this.useOnMainDisplay = model.UseOnMainDisplay;
		this.useBackgroundMusic = model.UseBackgroundMusic;
		this.animationId = model.AnimationId
		
		this.categoriesIds = (model.Categories || []).map(x => x.Id);

		const langs = this.translations.map(x => x.langCode);
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
				tr.description = serverTranslation.Description;
			}
		});
		const counts = model.Translations.map(x=>(x.VoiceFiles || []).length || 0);
		const audioCount = Math.max(...counts);
		this.backgroundImage.ImageUrl = model.BackUrl;
		this.coverImage.ImageUrl = model.CoverUrl;
		this.audios = Array(audioCount).fill(0).map(x=> new AudioGroupViewModel(langs));
		this.audios.forEach((audioGroup, i) => {
			audioGroup.audios = [];
			const audios = this.translations.map(x=>{
					const voiceFiles = ((model.Translations.find(mt => mt.LangCode == x.langCode) || {}).VoiceFiles || [])
					return {
						langCode: x.langCode,
						file: ((voiceFiles || [])[i] || new VoiceFileResponse({Url: null}))
				}
			}).filter(x=>x.file!=null);
			if (audios != null && audios.length > 0) {
				audioGroup.audios = audios.map(x=> new MeditationAudioViewModel({
					id: x.file.Id,
					langCode: x.langCode,
					name: x.file.Name,
					isPaid: x.file.IsPaid,
					audioUrl: x.file.Url
				}));
			}
		});
	}
}
